'use client';
import type { ComponentProps } from 'react';
import { Typography } from '@bgzt/ui';
import { TextModel } from '~/types/common';

type Props = {
  textModel: TextModel;
};

type TypographyProps = ComponentProps<typeof Typography>;

const KEY_PLACEHOLDER = '{key}';

const getTypographyProps = (
  attribute?: { typography?: string; color?: string },
  defaults: Pick<TypographyProps, 'variant' | 'color'> = { variant: 'L12', color: 'gray-900' },
): Pick<TypographyProps, 'variant' | 'color'> => ({
  variant: (attribute?.typography ?? defaults.variant) as TypographyProps['variant'],
  color: (attribute?.color ?? defaults.color) as TypographyProps['color'],
});

export const TextModelRenderer = ({ textModel }: Props) => {
  const textParts = textModel.main.text.split(/(\{key\})/);

  const renderSubText = (sub: NonNullable<typeof textModel.sub>[0], subIndex: number) => (
    <Typography key={`sub-${subIndex}`} {...getTypographyProps(sub.attribute, { variant: 'L11', color: 'gray-900' })}>
      {sub.text}
    </Typography>
  );

  const renderTextPart = (part: string, index: number) => {
    if (part !== KEY_PLACEHOLDER) {
      return part;
    }

    const subIndex = Math.floor(index / 2);
    const sub = textModel.sub?.[subIndex];

    return sub ? renderSubText(sub, subIndex) : null;
  };

  return <Typography {...getTypographyProps(textModel.main.attribute)}>{textParts.map(renderTextPart)}</Typography>;
};
